export default __webpack_public_path__ + "static/media/triangle.b2d911b2.png";